// Module
var code = `<ng-form name="\$ctrl.form">
  <validator condition="\$ctrl.isConfigurationValid()"></validator>

  <table class="table table--generate-row-ids">
    <thead>
    <tr>
      <th>Level</th>
      <th>Roles</th>
      <th>Users</th>
      <th class="table__column-to-right">Actions</th>
      <th></th>
    </tr>
    </thead>
    <tbody dragula="'{{ \$ctrl.dragulaBagName }}'" dragula-model="\$ctrl.approvalHierarchy">
    <tr ng-repeat="approval in \$ctrl.approvalHierarchy" class="approval-hierarchy-row">
      <td></td>
      <td>
        <multiselect items="\$ctrl.roles"
                     ng-model="approval.authorizedRoleIds"
                     label-property="'name'"
                     value-property="'id'"
                     ng-required="!\$ctrl.usersAreSetUp(approval.authorizedUserIds)"></multiselect>
      </td>
      <td>
        <selectize config="\$ctrl.userSelectConfig"
                   options="\$ctrl.users"
                   ng-model="approval.authorizedUserIds"
                   ng-required="!\$ctrl.rolesAreSetUp(approval.authorizedRoleIds)"></selectize>
      </td>
      <td>
        <div class="table__actions">
          <button type="button" ng-click="\$ctrl.removeLevel(\$index)" class="btn btn-danger">Remove</button>
          <button type="button" class="btn handler"><i class="icon-align-justify handler-icon"></i>Move</button>
        </div>
      </td>
      <td>
        <div ng-if="!\$ctrl.isApprovalLevelValid(approval)" class="alert alert--danger alert--no-margin">Either role or user is required.</div>
      </td>
    </tr>
    </tbody>
    <tbody>
    <tr>
      <td></td>
      <td></td>
      <td></td>
      <td>
        <button type="button" ng-click="\$ctrl.addLevel()" class="btn btn-success">Add</button>
      </td>
      <td></td>
    </tr>
    </tbody>
  </table>
</ng-form>

<div class="clearfix"></div>

<div class="summary-actions">
  <button type="submit"
    ng-if="!\$ctrl.useExternalSaveAction"
    ng-click="\$ctrl.save(\$ctrl.approvalHierarchy)"
    ng-disabled="\$ctrl.form.\$invalid || \$ctrl.form.\$pristine"
    class="btn btn-primary">
    Save
  </button>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/approval-hierarchy/approval-hierarchy.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;